<template>
  <div class="mega-menu container py-0">
    <v-row>
      <v-col cols="4" class="pa-0" v-for="type in category.types" :key="type.id">
        <div class="mega-menu-title" :class="type.name.toLowerCase()">
          <img
            :src="require('@/assets/materials.svg')"
            class="mr-1"
            alt="logo"
          />
          {{type.name}}
        </div>
        <div class="mega-menu-container" :class="type.name.toLowerCase()">
          <v-row>
            <v-col cols="12" sm="6">
              <a
                @click="searchProducts(subcategory, type)"
                v-for="(subcategory, index) in type.subCategories"
                :key="index"
                >{{ subcategory.name }}</a
              >
            </v-col>
          </v-row>
        </div>
      </v-col>
      <!-- <v-col cols="4" class="pa-0">
        <div class="mega-menu-title instruments">
          <img
            :src="require('@/assets/instruments.svg')"
            class="mr-1"
            alt="logo"
          />
          Instruments
        </div>
        <div class="mega-menu-container instruments">
          <v-row>
            <v-col cols="12">
              <a
                @click="searchProducts(item)"
                v-for="(item, index) in selected.Instruments"
                :key="index"
                >{{ item.name }}</a
              >
            </v-col>
          </v-row>
        </div>
      </v-col> -->
      <!-- <v-col cols="4" class="pa-0">
        <div class="mega-menu-title equipment">
          <img
            :src="require('@/assets/equipment.svg')"
            class="mr-1"
            alt="logo"
            width="14"
          />
          Equipment
        </div>
        <div class="mega-menu-container equipment">
          <v-row>
            <v-col cols="12">
              <a
                @click="searchProducts(item)"
                v-for="(item, index) in selected.Equipment"
                :key="index"
                >{{ item.name }}</a
              >
            </v-col>
          </v-row>
        </div>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MegaMenu",
  props: ['category'],
  computed: {
    ...mapState({
      categories: state => state.product.categories
    })
  },
  methods: {
    searchProducts(subcategory, type) {
      window.location.href = '/search/?products[refinementList][subCategories.category.name][0]='+this.category.name+'&products[refinementList][subCategories.productSubCategoryType.name][0]='+type.name+'&products[refinementList][subCategories.name][0]='+subcategory.name+'&products[page]=1'
    }
  }
};
</script>

<style scoped lang="scss" src="./SubMenu.scss"></style>